module.exports = __webpack_public_path__ + "img/sieckFinesseRelease1.b1ebab38.png";